/**
 * Language middleware - syncs all language systems when Redux action is dispatched
 * localStorage is the single source of truth
 */
export const languageMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  if (action.type === 'language/setLanguage') {
    const newLanguage = action.payload;
    // Use the helper to sync all systems
    changeLanguage(newLanguage);
  }

  return result;
};

/**
 * Helper function to change language from anywhere in the app
 * This is the preferred way to change language - updates localStorage and notifies all listeners
 */
export const changeLanguage = (newLanguage) => {
  // Update localStorage (single source of truth)
  localStorage.setItem('preferredLanguage', newLanguage);
  localStorage.setItem('selectedLanguage', newLanguage);

  // Dispatch event to notify useTranslations hook and other listeners
  window.dispatchEvent(new Event('languageChange'));

  // Sync with i18next
  import('../../i18n').then((i18nModule) => {
    const i18n = i18nModule.default;
    if (i18n?.changeLanguage && i18n.language !== newLanguage) {
      i18n.changeLanguage(newLanguage);
    }
  }).catch(() => {});
};
